import { render, staticRenderFns } from "./BudgetTable.vue?vue&type=template&id=47d8cce8&scoped=true"
import script from "./BudgetTable.vue?vue&type=script&lang=ts"
export * from "./BudgetTable.vue?vue&type=script&lang=ts"
import style0 from "./BudgetTable.vue?vue&type=style&index=0&id=47d8cce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8cce8",
  null
  
)

export default component.exports